export const nullIfUndefined = (value) => (value === undefined ? null : value);
